import type {SagaIterator} from 'redux-saga';

import {PRODUCT} from 'constants/actions';

import {takeEvery, call, put, putResolve, all, select} from 'redux-saga/effects';
import {fetchReviews, fetchReviewsWithPhotos} from 'actions/product/reviews/reviews';
import {DirectAdd} from 'libs/bronto/direct';
import {setCollapse} from 'actions/collapses/collapses';
import {getParentProduct} from 'selectors/product/product';

/**
 * Sends analytics to bronto.
 *
 * @param {{meta: ProductReviewFormType}} review - review form data
 */
export function* sendAnalyticsToBronto(): SagaIterator {
    const currentDate = yield new Date();
    yield call([DirectAdd, 'dateToBrontoDate'], currentDate);
}

/**
 * Product Reviews Saga.
 */
export function* productReviewsSaga(): SagaIterator {
    yield takeEvery(`${PRODUCT.SEND_REVIEW}_FULFILLED`, sendAnalyticsToBronto);
}

/**
 * Fetches reviews for active product
 * @param {number} id - product id
 */
export function* fetchProductReviews(id: number): SagaIterator {
    const parentProduct = yield select(getParentProduct);
    yield all([
        putResolve(fetchReviews(id, 2, 0)),
        putResolve(
            fetchReviewsWithPhotos({
                productIds: [id],
                parentProductId: parentProduct?.id,
            }),
        ),
    ]);
}

/**
 * Show review block if hash equal review tab it hash appears from the link on baseInfo
 */
export function* showReviewBlock() {
    if (window.location.hash === '#reviewsList') yield put(setCollapse('PDP_reviews', false));
}
